module.exports = __webpack_public_path__ + "media/Loops Drums.5a9a6028.wav";